import type { GoOfflineConfig } from "../../src/types";
import { createServiceWorkerTemplate } from "../../src/sw/sw-template";

export function generateServiceWorker(config: GoOfflineConfig): string {
  return createServiceWorkerTemplate(config);
}
